// removed by extract-text-webpack-plugin
module.exports = {"aspectRatio":"general__aspectRatio___1sPWU position-relative","aspectRatioContent":"general__aspectRatioContent___2dE_y position-absolute pinFill"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-aspect-ratio/AspectRatio/style/general.css
// module id = 85
// module chunks = 0 30